"use strict";

const cards = require("js/cards");
const eventStream = require("js/eventstream");
const keyboard = require("js/keyboard");

class AbstractFilter extends HTMLElement {
    constructor() {
        super();

        this.__root = this.attachShadow({ mode: "open" });

        this.__root.addEventListener("keydown", (e) => {
            // do not trigger search when user is selecting elements from selector drop down
            if (!e.defaultPrevented && (e.which == keyboard.keys.key_enter || e.which == keyboard.keys.key_return)) {
                console.log("ENTER or RETURN pressed: Trigger search due to keypress");
                this.search(e);
            }
        });

        this.__results = eventStream.eventSource();
    }

    connectedCallback() {
        // guard the connected callback against multiple runs for all subclasses
        // required because we sometimes remove and readd the filters from the DOM
        if (this.__root.childElementCount == 0) {
            this.__abstractConnectedCallback();
        }
    }

    __abstractConnectedCallback() {
        throw "subclasses must implement this function";
    }

    get results() {
        return this.__results;
    }

    __filterId() {
        let id = this.getAttribute("filterId");
        id = id == "" ? null : id;
        return id;
    }

    focus() {
        this.__root.querySelector(this.__focusSelector()).focus();
    }

    search() {
        console.error("This is an abstract function that must be implemented by the subclass!");
    }

    reset() {
        console.error("This is an abstract function that must be implemented by the subclass!");
    }
}

export { AbstractFilter };
